<template>
  <div id="time-series">
    <div class="container-fluid">
      <v-row v-if="items_time_series.meta">
        <label class="label-head">ข้อมูลตามเวลา</label>
      </v-row>
      <v-row style="padding-top: 5px" v-if="items_time_series.meta">
        <div class="table-responsive">
          <table style="width: 100%; margin-top: 5%">
            <thead style="background-color: #262628;" align="center">
            <tr>
              <th v-for="item in items_time_series.meta.header"
                  :colspan="item.colspan"
                  :rowspan="item.rowspan"
                  style="background-color: #262628;">
                <div>{{ item.label }}</div>
              </th>
            </tr>
            <tr v-if="items_time_series.meta.header2.length > 0">
              <th
                v-for="item in items_time_series.meta.header2"
                :colspan="item.colspan"
                :rowspan="item.rowspan">
                {{ item }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,key) in items_time_series.dataset">
              <td>
                <div>{{item.label }}</div>
              </td>
              <td v-for="value in item.value">{{value }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Api from '../providers/Api'

  export default {
    name: "TimeSeries",
    data() {
      return {
        date_range_from: this.$route.query.date_range_from || null,
        date_range_to: this.$route.query.date_range_to || null,
        freq: this.$route.query.freq || null,
        show_data_predict: this.$route.query.show_data_predict || null,
        show_line_alert: this.$route.query.show_line_alert || null,
        logger_id: this.$route.query.logger_id || null,
        fields: this.$route.query.fields || null,
        items_time_series: [],
      }
    },
    created() {
      this.getTimeSeries()
    },
    methods: {
      getTimeSeries(){
        if(!this.logger_id){
          return
        }
        this.post(`/api/analysis/mnf/get_by_time`, {
          date_range_from: this.date_range_from,
          date_range_to: this.date_range_to,
          freq: this.freq,
          show_data_predict: this.show_data_predict,
          show_line_alert: this.show_line_alert,
          loggers: [this.logger_id],
          fields: this.fields,
        }).then(res => {
          this.items_time_series = res && res.data
        })
      }
    },
    mixins: [
      Api,
    ],
  }

</script>

<style scoped>
  #time-series{
    padding: 10px;
    color: white;
  }
  table, th, td {
    border: 1px solid #666666;
  }
</style>
